import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { api } from '@core/api.js';
import { useNotify } from '@shared/hooks/useNotify.js';

const ROLES = [
  { key: 'ROLE_USER', label: 'Utilisateur' },
  { key: 'ROLE_ADMIN', label: 'Admin' },
  { key: 'ROLE_SUPER_ADMIN', label: 'Super admin' },
];

export default function UserFormDialog({ user, onClose }) {
  const isNew = !user?.id;
  const notify = useNotify();
  const [email, setEmail] = useState(user?.email || '');
  const [displayName, setDisplayName] = useState(user?.displayName || '');
  const [password, setPassword] = useState('');
  const [roles, setRoles] = useState(user?.roles || ['ROLE_USER']);
  const [saving, setSaving] = useState(false);

  const toggle = (role) =>
    setRoles((list) => list.includes(role) ? list.filter((r) => r !== role) : [...list, role]);

  const submit = async () => {
    setSaving(true);
    try {
      const payload = { email, displayName, roles };
      if (password) payload.password = password;
      if (isNew) await api.post('/v1/auth/users', payload);
      else await api.patch(`/v1/auth/users/${user.id}`, payload);
      notify.success(isNew ? 'Utilisateur créé' : 'Utilisateur mis à jour');
      onClose();
    } catch (err) {
      notify.error(err?.response?.data?.error || 'Échec de l’enregistrement');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>{isNew ? 'Nouvel utilisateur' : 'Modifier l’utilisateur'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={!isNew} />
          <TextField label="Nom affiché" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
          <TextField label={isNew ? 'Mot de passe' : 'Nouveau mot de passe (optionnel)'} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required={isNew} />
          <FormGroup row>
            {ROLES.map((r) => (
              <FormControlLabel
                key={r.key}
                control={<Checkbox checked={roles.includes(r.key)} onChange={() => toggle(r.key)} />}
                label={r.label}
              />
            ))}
          </FormGroup>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
        <Button variant="contained" onClick={submit} disabled={saving}>Enregistrer</Button>
      </DialogActions>
    </Dialog>
  );
}
